import type { ToolName } from '../types.ts';

// Slim status line shown mid-stream when the agent is calling a tool. Builds
// user trust that retrieval/computation is happening, not hallucination.
// Three states: running (cyan pulse + counter), done (green + final elapsed),
// error (red + error message replacing args).
export function ToolCallActivity({
  tool,
  args,
  elapsed,
  status,
}: {
  tool: ToolName | string;
  args: string;
  elapsed: string;
  status: 'running' | 'done' | 'error';
}) {
  const dotColor =
    status === 'running' ? 'var(--accent-2)' : status === 'done' ? 'var(--pos)' : 'var(--neg)';
  return (
    <div
      className="mono"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 10px',
        background: 'var(--bg-2)',
        border: '1px solid var(--line-1)',
        borderLeftWidth: 2,
        borderLeftColor: dotColor,
        borderRadius: 3,
        fontSize: 11,
        color: 'var(--fg-2)',
      }}
    >
      <span
        className={status === 'running' ? 'dot pulse' : 'dot'}
        style={{ background: dotColor }}
        aria-hidden="true"
      />
      <span className="caps" style={{ color: 'var(--fg-1)', letterSpacing: '0.06em' }}>
        {tool}
      </span>
      <span
        style={{
          color: 'var(--fg-3)',
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {args}
      </span>
      <span className="tabular" style={{ color: 'var(--fg-3)', fontSize: 10 }}>
        {elapsed}
      </span>
    </div>
  );
}
